import BalanceColor from './BalanceColor';

export default BalanceColor;
